module.exports = __webpack_public_path__ + "img/wedding.0695da46.svg";